<div
  id="addPresentationPage"
  [class.template-grid--portrait]="orientationFilter === 'portrait'"
>
  <div class="tw-py-8 tw-px-[16px]">
    <h1
      class="tw-text-center tw-mb-12 tw-mt-16 tw-text-[28px] tw-font-semibold"
    >
      Create your perfect presentation!
    </h1>
    @if (showAiButton()) {
      <div
        class="tw-flex tw-flex-col sm:!tw-flex-row tw-items-center tw-justify-center tw-gap-4 tw-py-2"
      >
        <button
          mat-flat-button
          color="primary"
          class="tw-w-80 tw-rounded-full"
          (click)="focusSearchInput()"
        >
          <mat-icon svgIcon="layout" aria-hidden="true"></mat-icon>
          <span>Search Templates</span>
        </button>
        <button
          matButton="outlined"
          class="tw-w-80 tw-rounded-full ai-button"
          [class.ai-button-ready]="!products.loadingItems"
          (click)="openAiGenerator()"
        >
          <mat-icon svgIcon="ai-gradient" aria-hidden="true"></mat-icon>
          <span>Generate with AI</span>
        </button>
      </div>
    }
    <div class="tw-mt-8 tw-mb-[72px] tw-w-[90%] md:!tw-w-[60%] tw-mx-auto">
      <search-filter
        [filterConfig]="filterConfig"
        [search]="search"
        [doSearch]="search.doSearch"
        [localSearch]="showSharedTemplates"
        [focus]="focusSearch"
      ></search-filter>
    </div>
    <div
      class="tw-flex tw-gap-4 tw-flex-col md:!tw-flex-row"
      rvSpinner="product-list-loader"
      [rvShowSpinner]="products.loadingItems"
    >
      <div
        id="template-filters"
        class="tw-w-[260px] tw-flex-shrink-0 sticky-scroll"
      >
        <div class="border-round">
          <mat-accordion displayMode="flat" multi="true">
            <mat-expansion-panel
              class="border-bottom expansion-panel-flush mat-elevation-z0"
              [disabled]="!datesAvailable"
              [expanded]="datesAvailable"
            >
              <mat-expansion-panel-header
                class="p-3 show-focus"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="datesAvailable"
                [attr.aria-disabled]="!datesAvailable"
                aria-controls="events-calendar-panel"
                id="events-calendar-button"
              >
                <h3 class="filter-section-title">Events Calendar</h3>
              </mat-expansion-panel-header>
              <div
                id="events-calendar-panel"
                role="region"
                aria-labelledby="events-calendar-button"
              >
                <template-calendar
                  [displayed]="datesAvailable"
                  [(selectedDate)]="selectedDate"
                  (selectedDateChange)="doSearch()"
                ></template-calendar>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <div class="p-3 border-bottom orientation-filter">
            <h3 id="orientation-filter-title" class="filter-section-title">
              Orientation
            </h3>
            <div
              class="orientation-filter__options"
              role="radiogroup"
              aria-labelledby="orientation-filter-title"
            >
              <button
                type="button"
                class="orientation-filter__option"
                [class.orientation-filter__option--selected]="
                  orientationFilter === 'landscape'
                "
                role="radio"
                [attr.aria-checked]="orientationFilter === 'landscape'"
                (click)="setOrientationFilter('landscape')"
                [disabled]="showSharedTemplates"
              >
                <mat-icon svgIcon="display" aria-hidden="true"></mat-icon>
                <span>Landscape</span>
              </button>
              <button
                type="button"
                class="orientation-filter__option"
                [class.orientation-filter__option--selected]="
                  orientationFilter === 'portrait'
                "
                role="radio"
                [attr.aria-checked]="orientationFilter === 'portrait'"
                (click)="setOrientationFilter('portrait')"
                [disabled]="showSharedTemplates"
              >
                <mat-icon svgIcon="portrait" aria-hidden="true"></mat-icon>
                <span>Portrait</span>
              </button>
            </div>
          </div>
          <mat-accordion displayMode="flat" multi="true">
            <mat-expansion-panel
              class="border-bottom mat-elevation-z0"
              [disabled]="!categoryFilters.templateCategories"
              [expanded]="preloadFilter"
            >
              <mat-expansion-panel-header
                class="p-3 show-focus"
                role="button"
                aria-level="3"
                tabindex="0"
                [attr.aria-expanded]="preloadFilter"
                [attr.aria-disabled]="!categoryFilters.templateCategories"
                aria-controls="category-panel"
                id="category-button"
              >
                <h3 class="filter-section-title">Category</h3>
              </mat-expansion-panel-header>
              <div
                id="category-panel"
                role="region"
                aria-labelledby="category-button"
              >
                @for (
                  category of categoryFilters.templateCategories;
                  track category
                ) {
                  <div>
                    <mat-checkbox
                      #FilterCheckbox
                      id="checkbox-templateCategories-{{
                        slugify(category.name)
                      }}"
                      (change)="
                        setFilter($event, 'templateCategories', category.name)
                      "
                      [disabled]="showSharedTemplates"
                    >
                      {{ category.name }} ({{ category.count }})
                    </mat-checkbox>
                  </div>
                }
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              class="border-bottom u_remove-radius mat-elevation-z0"
              [disabled]="!categoryFilters.templateContentTypes"
            >
              <mat-expansion-panel-header
                class="p-3 show-focus"
                role="button"
                aria-level="3"
                tabindex="0"
                [attr.aria-expanded]="!!categoryFilters.templateContentTypes"
                [attr.aria-disabled]="!categoryFilters.templateContentTypes"
                aria-controls="content-panel"
                id="content-button"
              >
                <h3 class="filter-section-title">Content</h3>
              </mat-expansion-panel-header>
              <div
                id="content-panel"
                role="region"
                aria-labelledby="content-button"
              >
                @for (
                  contentType of categoryFilters.templateContentTypes;
                  track contentType
                ) {
                  <div>
                    <mat-checkbox
                      #FilterCheckbox
                      id="checkbox-templateContentTypes-{{
                        slugify(contentType.name)
                      }}"
                      (change)="
                        setFilter(
                          $event,
                          'templateContentTypes',
                          contentType.name
                        )
                      "
                      [disabled]="showSharedTemplates"
                    >
                      {{ contentType.name }} ({{ contentType.count }})
                    </mat-checkbox>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <div
            class="flex-row left-right-aligner p-3"
            [ngClass]="{ 'border-bottom': templates.items.list.length }"
          >
            <label
              for="apple-tv-toggle"
              id="apple-tv-label"
              class="font-weight-normal mb-0 u_clickable"
              >Apple TV Compatible</label
            >
            <mat-slide-toggle
              id="apple-tv-toggle"
              class="pl-3"
              [checked]="filterAppleTv"
              (change)="toggleAppleTv()"
              [disabled]="showSharedTemplates"
              aria-labelledby="apple-tv-label"
            ></mat-slide-toggle>
          </div>
          <div
            class="flex-row left-right-aligner p-3"
            [shown]="templates.items.list.length"
          >
            <label
              for="templates-source-toggle-button"
              id="shared-templates-label"
              class="font-weight-normal mb-0 u_clickable"
              >Shared Templates</label
            >
            <mat-slide-toggle
              id="templates-source-toggle"
              class="pl-3"
              [checked]="showSharedTemplates"
              (change)="toggleTemplatesSource()"
              aria-labelledby="shared-templates-label"
            ></mat-slide-toggle>
          </div>
        </div>
      </div>
      <div id="template-grid" class="tw-flex-1 tw-min-w-0">
        <section id="productList">
          <div #TemplatesGrid>
            <ng-template #BlankPresentation>
              <!-- Template Image -->
              <div
                class="template-image"
                uiSref="apps.editor.workspace.artboard"
              >
                <img
                  loading="lazy"
                  class="img-responsive"
                  src="https://widgets.risevision.com/apps/logos/blank-landscape.png"
                  alt="add blank presentation"
                />
                <span class="cta">Use this Template</span>
                <span class="template-fx"></span>
              </div>
              <!-- Template Details -->
              <div class="template-details">
                <div class="template-title">
                  <span>Blank - Legacy Editor</span>
                </div>
                <div class="template-button">
                  <button
                    mat-icon-button
                    class="icon-button"
                    color="primary"
                    id="newPresentationButton"
                    uiSref="apps.editor.workspace.artboard"
                    aria-label="Use this template"
                  >
                    <mat-icon svgIcon="add" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </ng-template>
            <ng-template #Presentation let-product>
              @let imageUrl = getProductImageUrl(product);
              <!-- Template Image -->
              <div
                class="template-image"
                [ngClass]="{ shared: !imageUrl }"
                (click)="select(product)"
              >
                @if (imageUrl) {
                  <img
                    loading="lazy"
                    [src]="imageUrl"
                    alt="{{ product.imageAlt || product.name }}"
                  />
                } @else {
                  <streamline-icon
                    aria-hidden="true"
                    name="iconPresentation"
                    width="100%"
                    height="100%"
                  ></streamline-icon>
                }
                @if (imageUrl) {
                  <span class="cta">{{
                    isAlertTemplate(product)
                      ? 'Configure Alerts'
                      : 'Preview this Template'
                  }}</span>
                } @else {
                  <span class="cta">Use this Template</span>
                }
                <span class="template-fx"></span>
                <div class="template-tag" [shown]="product.templateTag">
                  {{ product.templateTag }}
                </div>
              </div>
              <!-- Template Details -->
              <div class="template-details">
                <div class="template-title">
                  <div class="flex-row">
                    <span id="productName-{{ slugify(product.name) }}">{{
                      product.name | slice: 0 : 65
                    }}</span>
                    @if (requiresUpgrade(product)) {
                      <upgrade-notice
                        feature="power_bi"
                        class="ml-2 mt-2"
                      ></upgrade-notice>
                    }
                  </div>
                </div>
                <div
                  class="template-button"
                  [ngClass]="{ 'alert-button': isAlertTemplate(product) }"
                >
                  <button
                    mat-flat-button
                    class="icon-button"
                    color="primary"
                    id="btn-{{ slugify(product.name) }}"
                    (click)="add(product)"
                    aria-label="Use this template"
                  >
                    <mat-icon
                      [svgIcon]="isAlertTemplate(product) ? 'settings' : 'add'"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </div>
            </ng-template>
            @if (!showSharedTemplates) {
              @if (!filteredResults && newTemplates.length) {
                <div>
                  @if (filteredUpcomingEvents.length) {
                    <div>
                      <h3 class="product-grid-header">Upcoming Events</h3>
                      <ul class="panel-body template-list">
                        @for (
                          template of filteredUpcomingEvents;
                          track template
                        ) {
                          <li
                            id="storeProduct-{{ slugify(template.name) }}"
                            class="template-card gallery-card"
                          >
                            <ng-container
                              *ngTemplateOutlet="
                                Presentation;
                                context: { $implicit: template }
                              "
                            ></ng-container>
                          </li>
                        }
                      </ul>
                    </div>
                  }

                  <h3 class="product-grid-header">Featured Templates</h3>
                  <ul class="panel-body template-list">
                    @for (template of newTemplates; track template) {
                      <li
                        id="storeProduct-{{ slugify(template.name) }}"
                        class="template-card gallery-card"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            Presentation;
                            context: { $implicit: template }
                          "
                        ></ng-container>
                      </li>
                    }
                  </ul>
                  <h3 class="product-grid-header">More Templates</h3>
                </div>
              }
              @if (!products.loadingItems && filteredResults) {
                <div>
                  @if (!showSharedTemplates) {
                    <div class="flex-row">
                      <h3 class="product-grid-header">Search Results</h3>
                      <mat-chip-set role="list">
                        @if (selectedDate) {
                          <mat-chip
                            role="listitem"
                            color="accent"
                            highlighted
                            (removed)="clearDate()"
                          >
                            {{ templatesService.formatDateName(selectedDate) }}
                            <button
                              matChipRemove
                              tabindex="0"
                              aria-label="Remove selected date"
                              (keydown.enter)="clearDate()"
                              (keydown.space)="clearDate()"
                            >
                              <streamline-icon
                                name="close"
                                width="12"
                                height="12"
                              ></streamline-icon>
                            </button>
                          </mat-chip>
                        }
                        @if (filterAppleTv) {
                          <mat-chip
                            role="listitem"
                            color="accent"
                            highlighted
                            (removed)="clearAppleTv()"
                          >
                            Apple TV
                            <button
                              matChipRemove
                              tabindex="0"
                              aria-label="Remove Apple TV filter"
                              (keydown.enter)="clearAppleTv()"
                              (keydown.space)="clearAppleTv()"
                            >
                              <streamline-icon
                                name="close"
                                width="12"
                                height="12"
                              ></streamline-icon>
                            </button>
                          </mat-chip>
                        }
                        @for (key of searchFilterKeys; track key) {
                          <span>
                            @for (
                              filter of search.templatesFilter[key];
                              track filter
                            ) {
                              <mat-chip
                                role="listitem"
                                color="accent"
                                highlighted
                                tabindex="0"
                                [value]="key + ':' + filter"
                                (keydown.enter)="
                                  clearFilter(key + ':' + filter)
                                "
                                (keydown.space)="
                                  clearFilter(key + ':' + filter)
                                "
                                (removed)="clearFilter($event.chip.value)"
                              >
                                {{ filter }}
                                <button
                                  matChipRemove
                                  [attr.aria-label]="
                                    'Remove ' + filter + ' filter'
                                  "
                                >
                                  <streamline-icon
                                    name="close"
                                    width="12"
                                    height="12"
                                  ></streamline-icon>
                                </button>
                              </mat-chip>
                            }
                          </span>
                        }
                        @if (
                          selectedDate ||
                          filterAppleTv ||
                          searchFilterKeys.length
                        ) {
                          <mat-chip
                            role="listitem"
                            color="accent"
                            highlighted
                            tabindex="0"
                            class="u_clickable inverted"
                            (click)="clearAllFilters()"
                            (keydown.enter)="clearAllFilters()"
                            (keydown.space)="clearAllFilters()"
                          >
                            Clear Filters
                          </mat-chip>
                        }
                      </mat-chip-set>
                    </div>
                  }
                </div>
              }
              @if (selectedDate) {
                <div>
                  @for (group of templateGroups; track group) {
                    <div>
                      <h6
                        class="product-grid-group-header"
                        [ngClass]="{ 'mt-2': group === templateGroups[0] }"
                      >
                        {{ group.name }}
                      </h6>
                      <ul class="panel-body template-list">
                        @for (template of group.templates; track template) {
                          <li
                            id="template-{{ slugify(template.name) }}"
                            class="template-card gallery-card"
                          >
                            <ng-container
                              *ngTemplateOutlet="
                                Presentation;
                                context: { $implicit: template }
                              "
                            ></ng-container>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                  @if (templateGroups?.length) {
                    <h3 class="product-grid-header">More Results</h3>
                  }
                </div>
              }

              <ul class="panel-body template-list">
                @for (template of filteredProducts; track template) {
                  <li
                    id="storeProduct-{{ slugify(template.name) }}"
                    class="template-card gallery-card"
                  >
                    @if (!template.isBlank) {
                      <div>
                        <ng-container
                          *ngTemplateOutlet="
                            Presentation;
                            context: { $implicit: template }
                          "
                        ></ng-container>
                      </div>
                    }
                    @if (template.isBlank) {
                      <ng-template
                        [ngTemplateOutlet]="BlankPresentation"
                      ></ng-template>
                    }
                  </li>
                }
                @if (
                  filteredProducts.length === 0 &&
                  search.query &&
                  !products.loadingItems
                ) {
                  @if (blankPresentationTemplate; as blankPresentation) {
                    <li
                      id="storeProduct-blank-presentation"
                      class="template-card gallery-card"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          Presentation;
                          context: { $implicit: blankPresentation }
                        "
                      ></ng-container>
                    </li>
                  }
                }
                @if (search.query && !products.loadingItems && showAiButton()) {
                  <li
                    id="generateWithAiTemplate"
                    class="template-card gallery-card ai-template-card"
                  >
                    <button
                      type="button"
                      class="ai-template-card__button"
                      (click)="openAiGenerator()"
                      [attr.aria-label]="
                        'Generate ' + search.query + ' with AI'
                      "
                    >
                      <span class="ai-template-card__image" aria-hidden="true">
                        <span class="ai-template-card__orbit">
                          <span class="ai-template-card__gradient"></span>
                          <span class="ai-template-card__gradient"></span>
                        </span>
                        <span class="ai-template-card__icon">
                          <mat-icon svgIcon="ai-gradient"></mat-icon>
                        </span>
                      </span>
                      <span class="ai-template-card__title">
                        {{
                          filteredProducts.length
                            ? 'Generate your template with AI'
                            : search.query + ' by AI'
                        }}
                      </span>
                    </button>
                  </li>
                }
                @if (search.query && !products.loadingItems) {
                  <li id="suggestTemplate" class="col-sm-12 text-center">
                    <span>Can’t find what you’re looking for? </span>
                    <a
                      href="https://docs.google.com/forms/d/1slHKxGxywkiSakMukDr4dMGLmhzhYhoU0F2BHP8FSd4/viewform"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Provide feedback
                    </a>
                  </li>
                }
              </ul>
              <!--panel-body-->
            } @else {
              <h3 class="product-grid-header">Shared Templates</h3>

              <ul class="panel-body template-list">
                @for (
                  sharedTemplate of filteredSharedTemplates;
                  track sharedTemplate
                ) {
                  <li
                    id="storeProduct-{{ slugify(sharedTemplate.name) }}"
                    class="template-card gallery-card"
                  >
                    <div>
                      <ng-container
                        *ngTemplateOutlet="
                          Presentation;
                          context: { $implicit: sharedTemplate }
                        "
                      ></ng-container>
                    </div>
                  </li>
                }
                <!-- If no search results -->
                <li
                  class="col-sm-12"
                  [shown]="
                    filteredSharedTemplates.length === 0 &&
                    search.query &&
                    !templates.loadingItems
                  "
                >
                  <div class="text-muted text-center u_padding-lg">
                    Your search didn't return any results.
                  </div>
                </li>
                <li
                  class="col-sm-12 text-center"
                  [shown]="
                    filteredSharedTemplates.length === 0 &&
                    !search.query &&
                    !templates.loadingItems
                  "
                >
                  <div class="text-muted text-center u_padding-lg">
                    <span [shown]="sharedTemplatesAvailable"
                      >There aren't any shared templates to select</span
                    >
                    <span [shown]="sharedTemplatesAvailable === null">
                      <a uiSref="apps.purchase.home">Subscribe now</a>
                      to access Shared Templates
                    </span>
                    <span
                      [shown]="
                        sharedTemplatesAvailable !== null &&
                        !sharedTemplatesAvailable
                      "
                    >
                      <a actionLink (click)="showUpgradePlanModal()"
                        >Upgrade Plan</a
                      >
                      to access Shared Templates
                    </span>
                  </div>
                </li>
              </ul>
              <!--panel-body-->
            }
          </div>
          <!--panel-->
        </section>
      </div>
    </div>
  </div>
</div>
